(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('scoreRadar', scoreRadar);

    function scoreRadar(lodash) {
        return {
            retrict: 'E',
            scope: {
                score: '=?',
                labels: "=?",
                labelTitle: "=?",
                options: "=?"
            },
            "template": "<div style='width: 280px;height: 320px;'><canvas></canvas></div>",
            link: function (scope, elem) {
                const options = lodash.extend({
                    elements: {
                        line: {
                            borderWidth: 1
                        }
                    }
                }, scope.options || {});

                const container = elem.find("canvas")[0];
                const myNewChart = new Chart(container, {
                    type: 'radar',
                    data: {
                        labels: scope.labels,
                        datasets: [{
                            label: scope.labelTitle,
                            data: scope.score.toJSON(),
                            borderWidth: 1
                        }]
                    },
                    options: options
                });
            },
        };
    }
})();